import { Box } from '@mui/material'
import { useContext } from 'react'

import { AuctionCardInView, NumberStatus, NumberStatusSize } from '../../Components'
import { BidderContext } from '../../Contexts'

const Lists: React.FC = () => {
  const { pendingCount, totalBids, geoTokensBidOn, geotokensOwned } = useContext(BidderContext)
  return (
    <Box display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center">
        <Box alignItems="center" display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center">
          <Box padding={1}>
            <NumberStatus size={NumberStatusSize.Small} title="Total Bids" value={totalBids} />
          </Box>
          <Box padding={1}>
            <NumberStatus size={NumberStatusSize.Small} title="Pending Geotokens" value={pendingCount} />
          </Box>
        </Box>
        <Box alignItems="center" display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center">
          <Box padding={1}>
            <NumberStatus size={NumberStatusSize.Small} title="Geotokens Bid On" value={geoTokensBidOn} />
          </Box>
          <Box padding={1}>
            <NumberStatus size={NumberStatusSize.Small} title="Owned Geotokens" value={geotokensOwned?.length} />
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        {geotokensOwned?.map((auction) => {
          return (
            <Box key={auction.quadkey.toHex()} margin={1}>
              <AuctionCardInView page="geotoken" quadkey={auction.quadkey} size="medium" />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default Lists
